import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

const AuthShell = ({
  eyebrow = "Proovam",
  title,
  description,
  children,
  panelTitle = "Proovam",
  panelDescription = "Turn customer proof into partner-led growth with BRMs, verified enrollments, and campaign-ready reporting.",
  backLabel = "Back to home",
}) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white font-sans text-gray-900 lg:grid lg:grid-cols-2">
      <section className="flex min-h-screen flex-col bg-white">
        <div className="px-4 py-5 sm:px-8 lg:px-12">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate("/")}
            className="-ml-2 h-10 rounded-lg px-2 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
            data-testid="back-to-home"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            {backLabel}
          </Button>
        </div>

        <div className="flex flex-1 items-center justify-center px-4 py-8 sm:px-8 lg:px-12">
          <div className="w-full max-w-md">
            <div className="mb-8">
              <div className="mb-8 flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-500 text-white shadow-theme-xs">
                  <ShieldCheck className="h-5 w-5" />
                </span>
                <span>
                  <span className="block text-base font-semibold text-gray-900">Proovam</span>
                  <span className="block text-xs text-gray-500">{eyebrow}</span>
                </span>
              </div>
              <h1 className="text-3xl font-semibold tracking-tight text-gray-900">{title}</h1>
              {description ? <p className="mt-3 text-sm leading-6 text-gray-500">{description}</p> : null}
            </div>

            {children}
          </div>
        </div>
      </section>

      <aside className="relative hidden min-h-screen overflow-hidden bg-[#11185f] lg:flex lg:items-center lg:justify-center">
        <div className="absolute inset-x-12 top-12 flex items-center justify-between text-white/70">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/10 text-white">
              <ShieldCheck className="h-5 w-5" />
            </span>
            <span className="text-sm font-semibold">Proovam</span>
          </div>
          <span className="rounded-full border border-white/15 px-3 py-1 text-xs">TailAdmin system</span>
        </div>

        <div className="mx-auto max-w-md px-10 text-center">
          <div className="mx-auto mb-8 grid h-24 w-24 place-items-center rounded-3xl bg-white/10 text-white shadow-[0_24px_80px_rgba(0,0,0,0.18)]">
            <ShieldCheck className="h-11 w-11" />
          </div>
          <h2 className="text-3xl font-semibold tracking-tight text-white">{panelTitle}</h2>
          <p className="mt-4 text-base leading-7 text-white/60">{panelDescription}</p>
        </div>

        <div className="absolute bottom-10 right-10 rounded-full bg-brand-500 px-4 py-2 text-xs font-semibold text-white shadow-theme-sm">
          Secure workspace
        </div>
      </aside>
    </div>
  );
};

export default AuthShell;
